const ContactType = {
    General: 'GENERAL',
    Appointment: 'APPOINTMENT',
    Information: 'INFORMATION',
    FilingAd: 'FILING_AD',
    CompanyAd: 'COMPANY_AD',
    LearnerAd: 'LEARNER_AD',
    Registration: 'REGISTRATION',
    Ecocamp: 'ECOCAMP',
};

export default ContactType;
